var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#808184",
    d: "M1.5,32h29c0.827,0,1.5-0.673,1.5-1.5v-29C32,0.673,31.327,0,30.5,0h-29C0.673,0,0,0.673,0,1.5v29 C0,31.327,0.673,32,1.5,32z M1,1.5C1,1.224,1.224,1,1.5,1h29C30.776,1,31,1.224,31,1.5v29c0,0.276-0.224,0.5-0.5,0.5h-29 C1.224,31,1,30.776,1,30.5V1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808184",
    d: "M20.224,20.367c0.098,0.098,0.226,0.146,0.354,0.146s0.256-0.049,0.354-0.146l4.014-4.014 c0.195-0.195,0.195-0.512,0-0.707l-4.014-4.014c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707l3.66,3.66l-3.66,3.66 C20.028,19.855,20.028,20.172,20.224,20.367z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808184",
    d: "M10.865,20.372c0.089,0.066,0.194,0.098,0.297,0.098c0.153,0,0.304-0.07,0.402-0.203 c0.165-0.222,0.118-0.535-0.104-0.699l-4.161-3.079l3.079-4.161c0.165-0.222,0.118-0.535-0.104-0.699 c-0.222-0.166-0.535-0.117-0.699,0.104l-3.376,4.563c-0.165,0.222-0.118,0.535,0.104,0.699L10.865,20.372z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808184",
    d: "M14.014,21.978c0.049,0.015,0.1,0.022,0.148,0.022c0.213,0,0.411-0.137,0.478-0.352l3.415-11 c0.082-0.264-0.065-0.544-0.329-0.626c-0.265-0.082-0.544,0.065-0.626,0.329l-3.415,11C13.603,21.616,13.75,21.896,14.014,21.978z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.4f0d75e0.svg";
export { ForwardRef as ReactComponent };